import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    content: String,
  }

  toggle(event) {
    const TARGETS = this.contentValue.split(",")
    this.toggleElements(TARGETS)
  }

  toggleElements(targets) {
    targets.forEach(target => {
      this.toggleElement(target)
    })
  }

  toggleElement(el) {
    const HIDDEN_CLASS = "hidden"
    $(el)[0].classList.toggle(HIDDEN_CLASS)
  }
}
